import { Close as CloseIcon } from '@mui/icons-material';
import { tableHeaderGrey } from 'common/styles/colors';
import { FC } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const CloseBtn = styled(Button).attrs(() => ({
  variant: 'transparent',
  type: 'button',
  'aria-label': 'close',
}))`
  padding: 0.2rem;
  :focus {
    outline: ${tableHeaderGrey} dotted 1px;
  }
  border-color: transparent;
`;

export interface CloseButtonProps {
  /**
   * The function that will take action when the form is closed. If not provided,
   * the default is to return to the previous page.
   */
  closeHandler?: () => void;

  /** The color of the close icon; table gray by default. */
  color?: string;

  /** Indicates whether the button should be disabled; `false` by default. */
  disabled?: boolean;
}

export const CloseButton: FC<CloseButtonProps> = ({
  closeHandler,
  color,
  disabled,
}) => {
  const history = useHistory();
  return (
    <CloseBtn onClick={closeHandler ?? history.goBack} disabled={disabled}>
      <CloseIcon htmlColor={color ?? tableHeaderGrey} />
    </CloseBtn>
  );
};
